<h2 mat-dialog-title>{{ data.title | translate }}</h2>
<mat-dialog-content class="mat-typography">
<form class="form-wrapper" [formGroup]="resetPasswortForm" autocomplete=off>

    <mat-form-field appearance="outline" color="accent">
      <mat-label>{{ 'pages.login.loginDialog.email' | translate }}</mat-label>
      <input
        matInput
        [placeholder]="'pages.login.loginDialog.email' | translate"
        formControlName="email"
      />
      <mat-error *ngIf="resetPasswortForm.controls.email.invalid">{{ getErrorMessage('email') | translate }}</mat-error>
    </mat-form-field>
</form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button
    id="abbruch"
    color="accent"
    (click)="noHandleClick()"
  >
    {{ data.cancelButtonLabel | translate }}
  </button>
  <button
    [disableRipple]="true"
    mat-raised-button
    color="accent"
    (click)="resetPasswort()"
    [disabled]="resetPasswortForm.invalid"
  >
    {{ data.submitButtonLabel | translate }}
  </button>
</mat-dialog-actions>
